
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LanguageIcon from '@mui/icons-material/Language';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import { Snowshoeing } from '@mui/icons-material';
import StyleIcon from '@mui/icons-material/Style';
import CelebrationIcon from '@mui/icons-material/Celebration';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import TtkList from './TtkList';
const FlourishTTK = ({ data }) => {

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><AutoFixHighIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b> Coverd Of Events :</b>&nbsp;<span> {data?.coverdofevents}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Serving Cities:</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Offered :</b>&nbsp;<TtkList data={data?.serviceOffered} /></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <Snowshoeing sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Planning Type :</b>&nbsp;<TtkList data={data?.planningType} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <DirectionsCarFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travel Preference :</b>&nbsp;<TtkList data={data?.travelPreference} /></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FlourishTTK